var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('Badge',{staticClass:"afu-font-sans afu-font-thin",class:_vm.badge.class,attrs:{"size":"xs"}},[_vm._v(_vm._s(_vm.badge.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }